import { MAIN_ROUTES } from "@/constants/routes";

export const POLICIES_CONSTANTS = [
  {
    LABEL: "General Policies",
    ID: "general-policies",
    ITEMS: [
      { name: "Accepted Use Policy ", path: MAIN_ROUTES.ACCEPTED_USE_POLICY },
      { name: "Code Of Conduct", path: MAIN_ROUTES.CODE_OF_CONDUCT },
      { name: "Digital Millenium Coypyright Act", path: MAIN_ROUTES.DMCA },
      {
        name: "Bandwidth and Backup Overages",
        path: MAIN_ROUTES.BANDWIDTH_BACKUP_OVERAGES,
      },
      {
        name: "OneMind Services: Industry-Leading Service Level Guarantee",
        path: MAIN_ROUTES.SERVICE_GUARANTEE,
      },
    ],
  },
  {
    LABEL: "Dedicated Servers Policies",
    ID: "dedicated-servers-policies",
    ITEMS: [
      {
        name: "OneMind's Hosting Master Services Agreement",
        path: MAIN_ROUTES.HOSTING_SERVICES_AGREEMENT,
      },
      {
        name: "OneMind's Dedicated Server Service Level Guarantee",
        path: MAIN_ROUTES.DEDICATED_SERVICE_LEVEL_GUARANTEE,
      },
    ],
  },
  {
    LABEL: "Cloud Servers Policies",
    ID: "cloud-servers-policies",
    ITEMS: [
      {
        name: "OneMind Cloud Service Level Agreement (SLA)",
        path: MAIN_ROUTES.CLOUD_SERVICE_LEVEL_AGREEMENT,
      },
      {
        name: "OneMind Cloud Terms of Service",
        path: MAIN_ROUTES.CLOUD_TERMS_OF_SERVICE,
      },
    ],
  },
  {
    LABEL: "Colocation Policies",
    ID: "colocation-policies",
    ITEMS: [
      {
        name: "OneMind Services Hosting Colocation Services Agreement",
        path: MAIN_ROUTES.HOSTING_COLOCATIONS_ERVICES_AGREEMENT,
      },
      {
        name: "OneMind Services Colocation Policies and Regulations",
        path: MAIN_ROUTES.COLOCATION_POLICIES_AND_REGULATIONS,
      },
    ],
  },
];
